import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useToast } from "../../core/contexts/toast";
import FiltroPI from "./filtro";
import { useAutenticação } from "../../core/contexts/auth";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, ArcElement } from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, ArcElement);
import InventoryInfoBox from "./InventoryInfoBox";
import SopInventoryGrowthChart from "./SopInventoryGrowthChart";
import "./index.scss";
import SopInventoryTable from "./SopInventoryTable";
import { ModeloSopInventory } from "../../core/models/sopInventory";
import { FiltroSopInventory, RepositorioSopInventory } from "../../core/repositories/sopInventoryRepositorio";
import SopInventoryRevenueStackedBarChart from "./SopInventoryRevenueStackedBarChart";
import SopInventoryRegionPieChart from "./SopInventoryRegionPieChart";
import SopInventoryForecastChart from "./SopInventoryKPIChart";

var contador: number = 0;

export default function SopInventory() {


  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()
  const [filtro, setFiltro] = useState(new FiltroSopInventory());
  const [lista, setLista] = useState<ModeloSopInventory[]>([])
  const [activeTab, setActiveTab] = useState<'home' | 'table'>('home');
  const [dayOfInventory, setDayOfInventory] = useState(0);
  const [inventoryTurnover, setInventoryTurnover] = useState(0);





  React.useEffect(() => {
    setTimeout(() => {
      atualizaTamanhoTabela()
      // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
      const observer = new MutationObserver(atualizaTamanhoTabela);
      if (bodyRef.current) {
        observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
      }
      return () => {
        observer.disconnect();
      };
    }, 1000);
  }, []);

  React.useEffect(() => {
    if (usuario && usuario.cod_usuario) {
      carregarDados(filtro, true)
    }
  }, [usuario]);


  function diferentes(filtroP: FiltroSopInventory) {
    return filtroP.dth_inicio != filtro.dth_inicio || filtroP.dth_fim != filtro.dth_fim || filtroP.cod_business_unit != filtro.cod_business_unit || filtroP.cod_industrial_plant != filtro.cod_industrial_plant || filtroP.cod_product_family != filtro.cod_product_family || filtroP.cod_product != filtro.cod_product || filtroP.value != filtro.value
  }
  async function carregarDados(filtroP: FiltroSopInventory, forca = false) {
    try {
      if (forca || diferentes(filtroP)) {
        filtroP.cod_usuario = usuario?.cod_usuario
        const _contador = contador++;
        if (_contador === contador - 1) {
          const resposta = await new RepositorioSopInventory().getFilter(filtroP)
          console.log(resposta)
          setLista(resposta)

          const respostaKpis = await new RepositorioSopInventory().getCard(filtroP)
          setDayOfInventory(respostaKpis[0].doh)
          setInventoryTurnover(respostaKpis[0].turn)

        }
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(filtroP: FiltroSopInventory) {
    if (diferentes(filtroP)) {
      carregarDados(filtroP);
      setFiltro({ ...filtroP });
    }
  }

  async function filtrarDados(novoFiltro: FiltroSopInventory) {
    novoFiltro.flg_aberto = false
    atualizarFiltro(novoFiltro)
    // carregarDados(novoFiltro);
  }


  return (
    <div className="sazonalidade " ref={bodyRef}>
      <div className="px-2">

        <FiltroPI
          titulo={t("Inventory")}
          filtro={{ ...filtro }}
          atualizarFiltro={atualizarFiltro}
          permissaoEditar={true}
          filtrarDados={filtrarDados}
        />
      </div>




      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">

            <div className="tabs-container card px-2  shadow-sm border-0">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
                    onClick={() => setActiveTab('home')}
                  >
                    Home
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'table' ? 'active' : ''}`}
                    onClick={() => setActiveTab('table')}
                  >
                    Table
                  </button>
                </li>
              </ul>

              <div className="tab-content py-2 ">
                {activeTab === 'home' && (
                  <div>
                    <Row className="">
                      <Col md={3}>
                        <Card>
                          <InventoryInfoBox title="Days of Inventory on Hand" value={dayOfInventory?.toFixed()} />
                        </Card>
                        <Card className="mt-2">
                          <InventoryInfoBox title="Inventory Turnover" value={inventoryTurnover?.toFixed(2)} />
                        </Card>
                      </Col>

                      <Col md={6}>
                        <Card>
                          <SopInventoryForecastChart filtro={filtro} />
                        </Card>
                      </Col>
                      <Col md={3}>
                        <Card>
                          <div className="blue-line">
                            <SopInventoryRegionPieChart filtro={filtro} />
                          </div>
                        </Card>
                      </Col>
                    </Row>

                    <Row className=" mt-3">
                      <Col md={6}>
                        <Card>
                          <SopInventoryGrowthChart filtro={filtro} />
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card>
                          <SopInventoryRevenueStackedBarChart filtro={filtro} />
                        </Card>
                      </Col>


                    </Row>
                  </div>
                )}

                {activeTab === 'table' && (
                  <div>
                    <div className="table-100" >
                      <strong className=" title-card pb-1">Inventory vs Forecast vs Budget Table</strong>
                      <div className="py-2">
                        <SopInventoryTable lista={lista} setLista={setLista} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>




    </div>
  );
}
